<div class="chart-data-container">
  <!-- Configuration Section -->
  <div class="config-section">
    <!-- Enable feature checkbox -->
    @if (showDynaDimmerEnabledProp && !hideAll) {
      <div class="config-row enable-feature-row">
        <label class="config-label">
          <span class="label-text">Enable feature</span>
          <input type="checkbox" class="primary-checkbox" id="EnableDyna"
            (change)="enableDynaGraph($event.target.checked)" [(ngModel)]="dynaEnableMode"
            [checked]='dynaEnableMode' aria-label="Enable feature" />
            <span id="Dynadimmer-enablefeature-checkbox" class="checkbox-border"></span>
          </label>
        </div>
      }

      <!-- Override checkbox -->
      @if (showDynaOverrideProp && !dynaOverrideMessage && !hideAll) {
        <div
          class="config-row" [ngClass]="{'disabled-section': disable}">
          <label class="config-label" aria-hidden="true">
            <span class="label-text">Override</span>
            <input type="checkbox" class="primary-checkbox" id="OverrrideDyna"
              [disabled]="disable" [checked]='dynaOverrideMode'
              (change)="toggleOverrideMode($event.target.checked)" aria-label="Override" />
              <span id="Dynadimmer-override-checkbox" class="checkbox-border"></span>
            </label>
          </div>
        }

        <!-- Override warning message -->
        @if (!showDynaOverrideProp && dynaOverrideMessage && !hideAll) {
          <div class="config-row warning-row">
            <img id="Dynadimmer-override-warning-icon"
              src="{{pathVal}}icon_indicator_alert_high_16dip.png"
              class="warning-icon" alt="Warning">
              <span id="Dynadimmer-override-message" class="warning-text">
                Override is controlled by Dimming Interface
              </span>
            </div>
          }

          <!-- Time based checkbox -->
          @if (showDynaTimeReferenceProp) {
            <div
              class="config-row" [ngClass]="{'disabled-section': disable}">
              <label class="config-label" aria-hidden="true">
                <span id="Dynadimmer-timeBased-text" class="label-text">Time based</span>
                <input type="checkbox" class="primary-checkbox" id="TimeBasedDyna"
                  [disabled]="disable" [(ngModel)]="dynaTimeReferenceMode"
                  [checked]="dynaTimeReferenceMode"
                  (change)="toggleTimeReference($event.target.checked)"
                  (click)="timeBaseclicked()"
                  (keydown)="$event.stopPropagation()"
                  (mouseleave)="onMouseLeave()"
                  aria-label="Time based" />
                  <span id="Dynadimmer-timeBased-checkbox" class="checkbox-border"></span>
                </label>
              </div>
            }

            <!-- Midnight shift section -->
            <div class="config-row midnight-shift-row" [ngClass]="{'disabled-section': disable}">
              <label class="midnight-label" for="MidnightShiftDyna">
                <span id="Dynadimmer-midnightShift-text" class="label-text">
                  Midnight<br>shift
                </span>
              </label>
              <input type="number"
                id="MidnightShiftDyna"
                class="midnight-input form-control"
                [(ngModel)]="midnightShiftEditedValue"
                [value]="midnightShiftEditedValue"
                [disabled]='dynaTimeReferenceMode || disable'
                min="-120"
                max="120"
                [ngClass]="{'is-invalid': !validMidNightPoint}"
                (keypress)="onMidnightShiftKeyPress($event)"
                (paste)="onMidnightShiftPaste($event)"
                (input)="textValChanged($event.target.value)"
                (keydown)="onKey1($event)"
                (mouseleave)="onMouseLeave()" />
                <span id="Dynadimmer-Minutes-text" class="unit-label">Minutes</span>
                <button id="Dynadimmer-calculate-btn"
                  class="calculate-btn"
                  [disabled]='dynaTimeReferenceMode || disable'
                (click)="calculateMidnightShiftTime()">Calculate</button>
              </div>
            </div>

            <!-- Schedule Table Section -->
            <div class="schedule-section" [ngClass]="{'disabled-section': disable}">
              <h3 id="Dynadimmer-schedule-text" class="schedule-title">Schedule</h3>

              <div class="table-container">
                <div id="Dynadimmer-tableValues-section" class="table-content" [formGroup]="addForm"
                  [attr.disabled]="disable ? '' : null"
                  [attr.aria-disabled]="disable ? 'true' : null">

                  <!-- Table Header -->
                  <div id="Dynadimmer-tableValues-headers" class="table-header">
                    <div id="Dynadimmer-time-header" class="header-cell time-col">
                      <span class="header-label">Time</span>
                      <span class="header-unit">hh:mm</span>
                    </div>
                    <div id="Dynadimmer-outputLevel-header" class="header-cell output-col">
                      <span class="header-label">Output level</span>
                      <span class="header-unit">%</span>
                    </div>
                    <div id="Dynadimmer-fadeTime-header" class="header-cell fade-col">
                      <span class="header-label">Fade time</span>
                      <span class="header-unit">sec</span>
                    </div>
                    <div class="header-cell action-col">
                      <button id="Dynadimmer-clearFields-btn"
                        class="clear-btn"
                        (click)="clearTableValueFields()"
                        [disabled]="disable"
                      type="button">Clear fields</button>
                    </div>
                  </div>

                  <!-- Table Body -->
                  <div class="table-body">
                    @for (row of addForm.get('rows')?.controls; track row; let index = $index) {
                      <div
                        class="table-row"
                        (contextmenu)="onRightClick($event, index); false">
                        <div class="row-cell time-col">
                          <input #testInput
                            type="text"
                            id="Dynadimmer-Scenes-timeHHMM-input-{{index}}"
                            class="form-control scene-input"
                            [formControl]="row.get('timeHHMM')"
                            [attr.tabindex]="disable ? -1 : 0"
                            placeholder="00:00"
                            maxlength="5"
                            (keypress)="onTimeKeyPress($event)"
                            (paste)="onTimePaste($event)"
                            (keydown)="onKey($event)"
                            (input)="onTimeInput()"
                            [ngClass]="{'is-invalid': row.get('timeHHMM').errors}" />
                          </div>
                          <div class="row-cell output-col">
                            <input type="text"
                              id="Dynadimmer-Scenes-outputLevel-input-{{index}}"
                              class="form-control scene-input"
                              [formControl]="row.get('outputLevel')"
                              [attr.tabindex]="disable ? -1 : 0"
                              placeholder="0"
                              maxlength="3"
                              min="0"
                              max="100"
                              (keypress)="onNumericKeyPress($event)"
                              (paste)="onNumericPaste($event)"
                              (input)="onOutputLevelInput($event, index)"
                              (keydown)="onKey($event)"
                              [ngClass]="{'is-invalid': row.get('outputLevel').errors}" />
                            </div>
                            <div class="row-cell fade-col">
                              <input type="text"
                                id="Dynadimmer-Scenes-fadeTime-input-{{index}}"
                                class="form-control scene-input"
                                [formControl]="row.get('fadeTime')"
                                [attr.tabindex]="disable ? -1 : 0"
                                placeholder="0"
                                maxlength="3"
                                min="0"
                                max="255"
                                (keypress)="onNumericKeyPress($event)"
                                (paste)="onNumericPaste($event)"
                                (input)="onFadeTimeInput($event, index)"
                                (keydown)="onKey($event)"
                                [ngClass]="{'is-invalid': row.get('fadeTime').errors}" />
                              </div>
                              <div class="row-cell action-col">
                                @if (rowLength > 1) {
                                  <button
                                    class="delete-btn"
                                    (click)="onUserRemoveRow(index)"
                                    id="Dynadimmer-Scenes-deleteRow-{{index}}"
                                    [disabled]="disable"
                                    (mouseleave)="onMouseLeave()"
                                    (mouseenter)="moMouseAddEnter()"
                                    type="button"
                                  aria-label="Delete row">&times;</button>
                                }
                              </div>
                            </div>
                          }
                        </div>

                        <!-- Table Footer -->
                        <div class="table-footer">
                          <span id="Dynadimmer-rowCount-text" class="row-count">
                            {{rowLength}} out of {{maxRowCount}} rows
                          </span>
                          <button id="Dynadimmer-Scenes-addRow-btn"
                            class="add-btn"
                            [disabled]="disableAddBtn || disable"
                            (click)="AddRow()"
                            (mouseenter)="moMouseAddEnter()"
                            (mouseleave)="onMouseLeave()"
                            type="button"
                          aria-label="Add row">+</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Context Menu for Add Row Above/Below -->
                <div #contextMenu class="context-menu"
                  [class.active]="menuState"
                  [ngStyle]="{'left':menuPositionX, 'top':menuPositionY}">
                  <button class="context-menu-item"
                    [disabled]="disableAddAboveBtn || disable"
                    (click)="addRowPosition('Above')"
                    type="button">
                    <span class="menu-icon">&#9650;</span> Add row above
                  </button>
                  <button class="context-menu-item"
                    [disabled]="disableAddBelowBtn || disable"
                    (click)="addRowPosition('Below')"
                    type="button">
                    <span class="menu-icon">&#9660;</span> Add row below
                  </button>
                </div>
